import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import App from './app'

import { createStore, applyMiddleware, compose } from 'redux'
import reducer from './reducer'
import thunkMiddleware from 'redux-thunk'
import persistState from 'redux-localstorage'



const devTools = window.devToolsExtension ? window.devToolsExtension() : a=>a
const store = createStore(
  reducer,
  compose(applyMiddleware(thunkMiddleware), persistState(null, {key: 'rist_redux'}), devTools)
)


ReactDOM.render(
  <AppContainer>
    <App store={store}/>
  </AppContainer>,
  document.getElementById('app')
)

if (module.hot) {
  module.hot.accept('./app', () => {
    const NextApp = require('./app').default
    ReactDOM.render(
      <AppContainer>
        <NextApp store={store}/>
      </AppContainer>,
      document.getElementById('app')
    )
  })
}



// WEBPACK FOOTER //
// ./src/index.js